<template>
    <div class="users-style">

        <!-- Abdullah added this code here  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Leave Type</span>
        </h4>

        <div class="row no-margin mt-4"> <!-- Abdullah added this code here  -->
            <div class="ibox col-md-12 px-4"> <!-- Abdullah added this code here  -->
                <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                <div class="ibox-title dashboard_title px-0"> <!-- Abdullah added this code here  -->
                    <h4>Leave Type</h4>
                </div>

                <div class="ibox-content px-0 pt-4 employee-table-wrapper"> <!-- Abdullah added this code here  -->
                    <div class="row no-gutters py-2 mb-3 pl-0"> <!-- Abdullah added this code here  -->
                        <div class="col-sm-6">
                            <div class="custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>

                        <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title" v-if="$acl['leave-attendances']==2"> <!-- Abdullah chnaged class here  -->
                            <!--<approver-leave-approve-settings ></approver-leave-approve-settings>-->

                            <!-- Abdullah commented this  -->
                            <!-- <b-button class="ml-3" id="show-btn" v-if="ce" @click="addNewLeaveType()"><b-icon icon="plus" ></b-icon> Add Leave Type</b-button> -->
                            <!-- Abdullah 17-05-26 added this + -->
                            <b-button id="show-btn" v-if="ce" @click="addNewLeaveType()">+ Add Leave Type</b-button>   <!-- Abdullah added this code here  -->
                        </div>
                    </div>
                    <b-overlay :show="showoverlay" rounded="sm">
                        <table class="table dataTable no-sort-icon"> <!-- Abdullah chnaged class here  -->
                            <thead>
                                <tr class="table-head">
                                    <!-- Abdullah26 added :style="{ fontSize: '16px' }" -->
                                    <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span :style="{ fontSize: '16px' }">{{column.label}}</span></th>
                                    <th class="">Legend Color</th> <!-- Abdullah chnaged class here  -->
                                    <th class="text-right" v-if="$acl['leave-attendances']==2">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="leavetype in paginatedData" :key="leavetype.id" v-if="leavetype.title != 'Long Service Leave'"> <!-- Ifti - 17-07-2025 -->
                                    <td>{{leavetype.title}}</td>
                                    <td>{{yes_no[leavetype.paid_flg].text  }}</td>
                                    <td>{{yes_no[leavetype.can_half].text  }}</td>
                                    <td>{{yes_no[leavetype.apportion].text  }}</td>
                                    <td>{{yes_no[leavetype.allow_encashment].text  }}</td>
                                    <td>{{yes_no[leavetype.carry_flg].text  }}</td>
                                    <!-- <td><div style="width:100px;" v-bind:style="'background:'+leavetype.color_code" >&nbsp;</div></td>    Abduullah commented this code-->
                                    <td><div style="border-radius: 4px; height: 36px;" v-bind:style="'background:'+leavetype.color_code" >&nbsp;</div></td>   <!-- Abdullah added this code here  -->
                                    <td v-if="$acl['leave-attendances']==2">

                                        <div class="float-right position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group >
                                                        <b-button variant="outline-secondary"  @click="editLeaveType(leavetype.id)">
                                                            <b-icon icon="pencil"></b-icon> Edit
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>

                                <!-- Abdullah commented this code  -->
                                <!-- <tr v-if="paginatedData.length > 0"><td :colspan="6">
                                <div class="row p-2 float-right" >
                                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                                </div></td></tr>
                                <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr> -->
                            </tbody>
                        </table>
                        <!-- Abdullah added this code here -->
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                                <div v-else class="row py-2 no-margin">
                                    <div class="col-md-12 p-0 no-margin">
                                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                                            <li class="page-item disabled m-2">View</li>
                                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                            <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                                        </ul>
                                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                                    </div>
                                </div>
                    </b-overlay>


                </div>
            </div>
        </div>

        <b-modal id="bv-modal-example" size="lg" hide-footer :title="leave_type_details">  <!-- Abdullah chnaged class here  -->


                <!--<ul class="list-group mb-3 " v-if='errormsg'>
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>-->

                <b-overlay :show="showoverlaymodal" rounded="sm">
                    <b-form @submit.stop.prevent="onSubmit">
                        <input type="hidden" v-model="fdata.id" name="id">

                        <!-- Abdullah commented this code  -->
<!--
                        <div class=" row">
                            <div class="col-sm-12">
                                <b-form-group id="title-group" label="Title" label-for="title">
                                    <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
                                    <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-4">
                                <b-form-group  id="can_half-group" label="Allow half day leave" class="required-field" label-for="can_half">
                                    <b-form-select id="can_half" name="can_half" v-model="fdata.can_half" :options="yes_no" ></b-form-select>
                                </b-form-group>
                            </div>
                        </div>

                        <div class=" row">
                            <div class="col-sm-8">
                                <b-form-group  id="paid_flg-group" label="Paid" class="required-field" label-for="paid_flg">
                                    <b-form-select id="paid_flg" name="paid_flg" v-model="fdata.paid_flg" v-validate="{ required: true }" :options="yes_no" :state="validateState('paid_flg')" aria-describedby="paid_flg-feedback" data-vv-as="Paid"></b-form-select>
                                    <b-form-invalid-feedback id="paid_flg-feedback">{{ veeErrors.first('paid_flg') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-4">
                                <b-form-group  id="can_exceed-group" label="Can Take Excess" class="required-field" label-for="can_exceed">
                                        <b-form-select id="can_exceed" name="can_exceed" v-model="fdata.can_exceed" :options="yes_no" ></b-form-select>
                                </b-form-group>
                            </div>
                        </div>
                        <div class=" row">
                            <div class="col-sm-4" >
                                <b-form-group  id="apportion-group" label="Apportion based on joining date" class="required-field" label-for="apportion">
                                    <b-form-select id="apportion" name="apportion" v-model="fdata.apportion" :options="yes_no" ></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-sm-4" v-if="fdata.apportion == 1">
                                <b-form-group  id="rounding-group" label="Rounding" class="required-field" label-for="rounding">
                                    <b-form-select id="rounding" name="rounding" v-model="fdata.rounding" :options="rounding_options" ></b-form-select>
                                </b-form-group>
                            </div>
                        </div>


                        <hr/>


                        <div class=" row">
                            <div class="col-sm-4">
                                <b-form-group  id="allow_encashment-group" label="Allow Encashment" class="required-field" label-for="allow_encashment">
                                    <b-form-select id="allow_encashment" name="allow_encashment" v-model="fdata.allow_encashment" :options="yes_no"></b-form-select>
                                </b-form-group>
                            </div>


                        </div>
                        <div class=" row" v-if="fdata.allow_encashment == 1">
                            <div class="col-sm-4">
                                <b-form-group id="encashable_days_based_on-group" class="required-field" label="Encashable Days Based On" label-for="encashable_days_based_on">
                                    <b-form-select id="encashable_days_based_on" @input="fdata.maximum_encashable_days_in_year = 0;" name="encashable_days_based_on" v-model="fdata.encashable_days_based_on" :options="encashable_days_based_on"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-4">
                              <b-form-group id="maximum_encashable_days_in_year-group" class="required-field" :label="'Maximum Encashable Days In Year ' + (fdata.encashable_days_based_on == 0 ? '(Days)' : '(%)')" label-for="maximum_encashable_days_in_year">
                                <b-form-input id="maximum_encashable_days_in_year" name="maximum_encashable_days_in_year" v-model="fdata.maximum_encashable_days_in_year" v-validate='{numeric:true}' :state="validateState('maximum_encashable_days_in_year')" aria-describedby="title-feedback" data-vv-as="Maximum Encashable Days In Year"></b-form-input>
                                <b-form-invalid-feedback id="maximum_encashable_days_in_year-feedback">{{ veeErrors.first('maximum_encashable_days_in_year') }}</b-form-invalid-feedback>
                              </b-form-group>
                            </div>
                        </div>

                        <div class=" row" v-if="fdata.allow_encashment == 1">

                            <div class="col-sm-4">
                                <b-form-group id="based_on_salary_type-group" class="required-field" label="Encashment on" label-for="based_on_salary_type">
                                    <b-form-select id="based_on_salary_type" @change="fdata.encashment_rate = 0;" name="based_on_salary_type" v-model="fdata.based_on_salary_type" :options="based_on_salary_types"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-4" v-if="fdata.based_on_salary_type == 2">
                              <b-form-group id="encashment_rate-group" class="required-field" label="Daily Rate of Encashment" label-for="encashment_rate">
                                <b-form-input id="encashment_rate" name="encashment_rate" v-model="fdata.encashment_rate"  v-validate='{numeric:true}' :state="validateState('encashment_rate')" aria-describedby="title-feedback" data-vv-as="Daily Rate of Encashment"></b-form-input>
                                <b-form-invalid-feedback id="encashment_rate-feedback">{{ veeErrors.first('encashment_rate') }}</b-form-invalid-feedback>
                              </b-form-group>
                            </div>
                        </div>


                        <div class=" row">


                            <div class="col-sm-4" v-if="fdata.allow_encashment == 1">
                                <b-form-group  id="allow_yearly_encashment_at_separation-group" label="Allow Yearly Encashment at Separation" label-for="allow_yearly_encashment_at_separation">
                                    <b-form-select id="allow_yearly_encashment_at_separation" name="allow_yearly_encashment_at_separation" v-model="fdata.allow_yearly_encashment_at_separation" :options="allow_yearly_encashment_at_separation"></b-form-select>
                                </b-form-group>
                            </div>

                        </div>

                      <hr/>

                        <div class="row">
                            <div class="col-sm-4">
                                <b-form-group  id="carry_flg-group" label="Allow Carry Forward" class="required-field" label-for="carry_flg">
                                    <b-form-select id="carry_flg" name="carry_flg" v-model="fdata.carry_flg" :options="yes_no" :state="validateState('carry_flg')" aria-describedby="carry_flg-feedback" data-vv-as="Carry Forward"></b-form-select>
                                    <b-form-invalid-feedback id="carry_flg-feedback">{{ veeErrors.first('carry_flg') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>


                        </div>

                        <div class="row" v-if="fdata.carry_flg == 1">
                          <div class="col-sm-4">
                            <b-form-group id="yearly_carry_forward_based_on-group" class="required-field" label="Yearly Carry Forward Based On" label-for="yearly_carry_forward_based_on">
                              <b-form-select id="yearly_carry_forward_based_on" @input="fdata.carry_days = 0;" name="yearly_carry_forward_based_on" v-model="fdata.full_carry" :options="yearly_carry_forward_based_on"></b-form-select>
                            </b-form-group>
                          </div>

                          <div class="col-sm-4" v-if="fdata.full_carry != 1">
                            <b-form-group id="carry_days-group" class="required-field" label="Carry Forward Limit in Year" label-for="carry_days">
                              <b-form-input id="carry_days" name="carry_days" v-model="fdata.carry_days"  v-validate='{numeric:true}' :state="validateState('carry_days')" aria-describedby="carry_days-feedback" data-vv-as="Maximum Carry Forward Days"></b-form-input>
                              <b-form-invalid-feedback id="carry_days-feedback">{{ veeErrors.first('carry_days') }}</b-form-invalid-feedback>
                            </b-form-group>
                          </div>
                        </div>


                        <div class=" row" v-if="fdata.carry_flg == 1">
                            <div class="col-sm-4" >
                              <b-form-group id="lifetime_carry_forward_limit-group" class="required-field" label="Set Lifetime Carry Forward Limit" label-for="lifetime_carry_forward_limit">
                                <b-form-select id="lifetime_carry_forward_limit" @input="fdata.max_carry_forward = 0;" name="lifetime_carry_forward_limit" v-model="fdata.lifetime_carry_forward_limit" :options="yes_no"></b-form-select>
                              </b-form-group>
                            </div>


                          <div class="col-sm-4" v-if="fdata.lifetime_carry_forward_limit == 1">
                            <b-form-group id="max_carry_forward-group" class="required-field" label="Lifetime Maximum Carry Forward Days" label-for="max_carry_forward">
                              <b-form-input id="max_carry_forward" name="max_carry_forward" v-model="fdata.max_carry_forward"  v-validate='{numeric:true}' :state="validateState('max_carry_forward')" aria-describedby="max_carry_forward-feedback" data-vv-as="Carry Forward Limit in Year"></b-form-input>
                              <b-form-invalid-feedback id="max_carry_forward-feedback">{{ veeErrors.first('max_carry_forward') }}</b-form-invalid-feedback>
                            </b-form-group>
                          </div>

                        </div>
                        <div class=" row" v-if="fdata.carry_flg == 1">
                            <div class="col-sm-4" >
                              <b-form-group id="allow_taking_leave_from_carry_balance-group" class="required-field" label="Allow Taking Leave From Carry Balance" label-for="allow_taking_leave_from_carry_balance">
                                <b-form-select id="allow_taking_leave_from_carry_balance" name="allow_taking_leave_from_carry_balance" v-model="fdata.allow_taking_leave_from_carry_balance" :options="yes_no"></b-form-select>
                              </b-form-group>
                            </div>
                            <div class="col-sm-4">
                              <b-form-group id="allow_encashment_on_carry_balance-group" class="required-field" label="Allow Encashment on Carry balance" label-for="allow_encashment_on_carry_balance">
                                <b-form-select id="allow_encashment_on_carry_balance" name="allow_encashment_on_carry_balance" v-model="fdata.allow_encashment_on_carry_balance" :options="allow_encashment_on_carry_balance"></b-form-select>
                              </b-form-group>
                            </div>
                        </div>


                        <hr/>

                        <div class="row">
                            <div class="col-sm-4">
                                <b-form-group  id="event-group" label="Usage Limit (Lifetime)" class="required-field" label-for="event">
                                    <b-form-select id="event" name="event" v-model="fdata.event" :options="event_options" :state="validateState('event')" aria-describedby="event-feedback" data-vv-as="Usage Limit (Lifetime)"></b-form-select>
                                    <b-form-invalid-feedback id="event-feedback">{{ veeErrors.first('event') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-4">
                                <b-form-group  id="ignore_off_day_on_leave-group" label="Ignore Weekend & Public Holidays Settings" class="required-field" label-for="ignore_off_day_on_leave">
                                    <b-form-select id="ignore_off_day_on_leave" name="ignore_off_day_on_leave" v-model="fdata.ignore_off_day_on_leave" :options="yes_no" :state="validateState('event')" aria-describedby="ignore_off_day_on_leave-feedback" data-vv-as="Ignore Weekend & Public Holidays Settings"></b-form-select>
                                    <b-form-invalid-feedback id="ignore_off_day_on_leave-feedback">{{ veeErrors.first('ignore_off_day_on_leave') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-4" v-if="fdata.ignore_off_day_on_leave == 1">
                                <b-form-group id="off_day_on_leave-group" label="Weekend & Public Holidays in Calculation" label-for="off_day_on_leave" >
                                    <b-form-select id="off_day_on_leave" :disabled="disabled_by_acl" name="off_day_on_leave" v-model="fdata.off_day_on_leave" :options="off_day_on_leave_options"  v-b-tooltip.hover title="Will be applicable from future leave application"></b-form-select>
                                </b-form-group>
                            </div>
                        </div>

                        <hr/>

                        <div class="row">

                            <div class="col-sm-4">
                                <b-form-group  id="override_leave_policy-group" label="Apply Custom Leave Policy" class="required-field" label-for="override_leave_policy">
                                    <b-form-select id="override_leave_policy" name="override_leave_policy" v-model="fdata.override_leave_policy" :options="yes_no" :state="validateState('event')" aria-describedby="override_leave_policy-feedback" data-vv-as="Apply Custom Leave Policy"></b-form-select>
                                    <b-form-invalid-feedback id="override_leave_policy-feedback">{{ veeErrors.first('override_leave_policy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-4" v-if="fdata.override_leave_policy == 1">
                                <b-form-group id="day_ratio-group" class="required-field" label="Present Days Required per Leave" label-for="day_ratio">
                                    <b-form-input id="day_ratio" name="day_ratio" v-model="fdata.day_ratio"  v-validate='{numeric:true}' :state="validateState('day_ratio')" aria-describedby="day_ratio-feedback" data-vv-as="Present Days Required per Leave"></b-form-input>
                                    <b-form-invalid-feedback id="day_ratio-feedback">{{ veeErrors.first('day_ratio') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </div>


                        <hr/>

                        <div class=" row">
                            <div class="col-sm-8">
                                <b-form-group id="color_code-group" class="required-field" :label="'Color Code ' + fdata.color_code" label-for="color_code">
                                    <b-form-input id="color_code" name="color_code" v-model="fdata.color_code" type="color"></b-form-input>
                                </b-form-group>
                            </div>
                        </div>



                        <b-button type="submit" variant="success">Submit</b-button>
                        <b-button class="ml-2" variant="success" @click="resetForm()">Reset</b-button> -->



                        <!-- Abdullah added this code  -->
                        <div class=" row">
                            <div class="col-sm-12">
                                <!-- Abdullah26 added class="required-field" -->
                                <b-form-group id="title-group" label="Title" label-for="title" class="required-field">
                                    <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
                                    <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- AbdullahFixed added this row here  -->
                        <div class=" row">
                            <div class="col-sm-6">
                                <b-form-group  id="can_half-group" label="Allow half day leave" class="required-field" label-for="can_half">
                                    <b-form-select id="can_half" name="can_half" v-model="fdata.can_half" :options="yes_no" ></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6">
                               <b-form-group  id="can_exceed-group" label="Can Take Excess" class="required-field" label-for="can_exceed">
                                    <b-form-select id="can_exceed" name="can_exceed" v-model="fdata.can_exceed" :options="yes_no" ></b-form-select>
                                </b-form-group>
                            </div>
                        </div>
                        <!-- AbdullahFixed added this row here up to this -->

                        <div class=" row">
                            <div class="col-sm-6">
                                <b-form-group  id="paid_flg-group" label="Paid" class="required-field" label-for="paid_flg">
                                    <b-form-select id="paid_flg" name="paid_flg" v-model="fdata.paid_flg" v-validate="{ required: true }" :options="yes_no" :state="validateState('paid_flg')" aria-describedby="paid_flg-feedback" data-vv-as="Paid"></b-form-select>
                                    <b-form-invalid-feedback id="paid_flg-feedback">{{ veeErrors.first('paid_flg') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6">
                                <div class="custom-color-inputs">
                                    <b-form-group id="color_code-group" class="custom_color_code_group">
                                        <label for="weekend_color_code" class="px-3 text-dark" style="font-size: 17px;">
                                            Color Code
                                            <span class="d-block text-secondary font-medium" style="font-size: 15px;">{{ fdata.color_code }}</span>
                                        </label>
                                        <b-form-input id="color_code" name="color_code" v-model="fdata.color_code" type="color"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div class=" row">
                            <div class="col-sm-6">
                                <b-form-group  id="apportion-group" label="Apportion based on joining date" class="required-field" label-for="apportion">
                                    <b-form-select id="apportion" name="apportion" v-model="fdata.apportion" :options="yes_no" ></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-sm-6" v-if="fdata.apportion == 1">
                                <b-form-group  id="rounding-group" label="Rounding" class="required-field" label-for="rounding">
                                    <b-form-select id="rounding" name="rounding" v-model="fdata.rounding" :options="rounding_options" ></b-form-select>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- AbdullahFixed added this row here  -->
                        <div class=" row">
                            <div class="col-sm-6">
                               <b-form-group  id="event-group" label="Usage Limit (Lifetime)" class="required-field" label-for="event">
                                    <b-form-select id="event" name="event" v-model="fdata.event" :options="event_options" :state="validateState('event')" aria-describedby="event-feedback" data-vv-as="Usage Limit (Lifetime)"></b-form-select>
                                    <b-form-invalid-feedback id="event-feedback">{{ veeErrors.first('event') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6">
                               <b-form-group  id="ignore_off_day_on_leave-group" label="Ignore Weekend & Public Holidays Settings" class="required-field" label-for="ignore_off_day_on_leave">
                                    <b-form-select id="ignore_off_day_on_leave" name="ignore_off_day_on_leave" v-model="fdata.ignore_off_day_on_leave" :options="yes_no" :state="validateState('event')" aria-describedby="ignore_off_day_on_leave-feedback" data-vv-as="Ignore Weekend & Public Holidays Settings"></b-form-select>
                                    <b-form-invalid-feedback id="ignore_off_day_on_leave-feedback">{{ veeErrors.first('ignore_off_day_on_leave') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.ignore_off_day_on_leave == 1">
                              <b-form-group id="off_day_on_leave-group" label="Weekend & Public Holidays in Calculation" label-for="off_day_on_leave" >
                                    <b-form-select id="off_day_on_leave" name="off_day_on_leave" v-model="fdata.off_day_on_leave" :options="off_day_on_leave_options"  v-b-tooltip.hover title="Will be applicable from future leave application"></b-form-select>
                                </b-form-group>
                            </div>
                        </div>

                         <div class=" row" v-if="fdata.carry_flg == 1">

                            <div class="col-sm-6" >
                                <b-form-group id="full_carry-group" label="Full Carry Forward Days" label-for="full_carry">
                                    <b-form-select id="full_carry" name="full_carry" v-model="fdata.full_carry" v-validate="{ required: true }" :options="yes_no" :state="validateState('full_carry')" aria-describedby="full_carry-feedback" data-vv-as="Full Carry Forward"></b-form-select>
                                    <b-form-invalid-feedback id="full_carry-feedback">{{ veeErrors.first('full_carry') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-6" >

                                <b-form-group v-if="fdata.full_carry == 0" id="carry_days-group" label="Maximum Carry Forward Days In Leave Year" label-for="carry_days">
                                    <b-form-input id="carry_days" name="carry_days" v-model="fdata.carry_days" v-validate="{ required: true }" :state="validateState('carry_days')" aria-describedby="carry_days-feedback" data-vv-as="Maximum Carry Forward Days"></b-form-input>
                                    <b-form-invalid-feedback id="carry_days-feedback">{{ veeErrors.first('carry_days') }}</b-form-invalid-feedback>
                                </b-form-group>


                            </div>

                        </div>


                        <div class=" row">
                            <div class="col-sm-6">
                                <b-form-group  id="override_leave_policy-group" label="Apply Custom Leave Policy" class="required-field" label-for="override_leave_policy">
                                    <b-form-select id="override_leave_policy" name="override_leave_policy" v-model="fdata.override_leave_policy" :options="yes_no" :state="validateState('event')" aria-describedby="override_leave_policy-feedback" data-vv-as="Apply Custom Leave Policy"></b-form-select>
                                    <b-form-invalid-feedback id="override_leave_policy-feedback">{{ veeErrors.first('override_leave_policy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.override_leave_policy == 1">
                              <b-form-group id="day_ratio-group" class="required-field" label="Present Days Required per Leave" label-for="day_ratio">
                                    <b-form-input id="day_ratio" name="day_ratio" v-model="fdata.day_ratio"  v-validate='{numeric:true}' :state="validateState('day_ratio')" aria-describedby="day_ratio-feedback" data-vv-as="Present Days Required per Leave"></b-form-input>
                                    <b-form-invalid-feedback id="day_ratio-feedback">{{ veeErrors.first('day_ratio') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </div>


                        <div class=" row">
                            <div class="col-sm-6">
                                <b-form-group  id="allow_encashment-group" label="Allow Encashment" class="required-field" label-for="allow_encashment">
                                    <b-form-select id="allow_encashment" name="allow_encashment" v-model="fdata.allow_encashment" :options="yes_no"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.allow_encashment == 1">
                                <b-form-group id="based_on_salary_type-group" label="Encashment on Basic or Gross Salary" label-for="based_on_salary_type">
                                    <b-form-select id="allow_encashment" name="allow_encashment" v-model="fdata.based_on_salary_type" :options="based_on_salary_types"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.allow_encashment == 1">
                                <b-form-group id="encashable_days_based_on-group" class="required-field" label="Encashable Days Based On" label-for="encashable_days_based_on">
                                    <b-form-select id="encashable_days_based_on" @input="fdata.maximum_encashable_days_in_year = 0;" name="encashable_days_based_on" v-model="fdata.encashable_days_based_on" :options="encashable_days_based_on"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.allow_encashment == 1">
                              <b-form-group id="maximum_encashable_days_in_year-group" class="required-field" :label="'Maximum Encashable Days In Year ' + (fdata.encashable_days_based_on == 0 ? '(Days)' : '(%)')" label-for="maximum_encashable_days_in_year">
                                <b-form-input id="maximum_encashable_days_in_year" name="maximum_encashable_days_in_year" v-model="fdata.maximum_encashable_days_in_year" v-validate='{numeric:true}' :state="validateState('maximum_encashable_days_in_year')" aria-describedby="title-feedback" data-vv-as="Maximum Encashable Days In Year"></b-form-input>
                                <b-form-invalid-feedback id="maximum_encashable_days_in_year-feedback">{{ veeErrors.first('maximum_encashable_days_in_year') }}</b-form-invalid-feedback>
                              </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.based_on_salary_type == 2">
                              <b-form-group id="encashment_rate-group" class="required-field" label="Daily Rate of Encashment" label-for="encashment_rate">
                                <b-form-input id="encashment_rate" name="encashment_rate" v-model="fdata.encashment_rate"  v-validate='{numeric:true}' :state="validateState('encashment_rate')" aria-describedby="title-feedback" data-vv-as="Daily Rate of Encashment"></b-form-input>
                                <b-form-invalid-feedback id="encashment_rate-feedback">{{ veeErrors.first('encashment_rate') }}</b-form-invalid-feedback>
                              </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.allow_encashment == 1">
                                <b-form-group  id="allow_yearly_encashment_at_separation-group" label="Allow Yearly Encashment at Separation" label-for="allow_yearly_encashment_at_separation">
                                    <b-form-select id="allow_yearly_encashment_at_separation" name="allow_yearly_encashment_at_separation" v-model="fdata.allow_yearly_encashment_at_separation" :options="allow_yearly_encashment_at_separation"></b-form-select>
                                </b-form-group>
                            </div>

                        </div>



                        <div class="row">
                            <div class="col-sm-6">
                                <b-form-group  id="carry_flg-group" label="Allow Carry Forward" class="required-field" label-for="carry_flg">
                                    <b-form-select id="carry_flg" name="carry_flg" v-model="fdata.carry_flg" :options="yes_no" :state="validateState('carry_flg')" aria-describedby="carry_flg-feedback" data-vv-as="Carry Forward"></b-form-select>
                                    <b-form-invalid-feedback id="carry_flg-feedback">{{ veeErrors.first('carry_flg') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.carry_flg == 1">
                                <b-form-group id="yearly_carry_forward_based_on-group" class="required-field" label="Yearly Carry Forward Based On" label-for="yearly_carry_forward_based_on">
                                <b-form-select id="yearly_carry_forward_based_on" @input="fdata.carry_days = 0;" name="yearly_carry_forward_based_on" v-model="fdata.full_carry" :options="yearly_carry_forward_based_on"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-4"  v-if="fdata.carry_flg == 1">
                                <b-form-group id="carry_days-group" class="required-field" label="Carry Forward Limit in Year" label-for="carry_days">
                                <b-form-input id="carry_days" name="carry_days" v-model="fdata.carry_days"  v-validate='{numeric:true}' :state="validateState('carry_days')" aria-describedby="carry_days-feedback" data-vv-as="Maximum Carry Forward Days"></b-form-input>
                                <b-form-invalid-feedback id="carry_days-feedback">{{ veeErrors.first('carry_days') }}</b-form-invalid-feedback>
                                </b-form-group>
                          </div>


                        </div>

                        <!-- AbdullahFixed added this row here up to this -->


                        <div class="btn-wrapper text-center pt-5">
                            <b-button class="ml-2 custom-wizard-btn" variant="primary" @click="resetForm()">Reset</b-button>
                            <b-button type="submit btn-primary" variant="primary">Submit</b-button>
                        </div>

                    </b-form>
                </b-overlay>
        </b-modal>

        <l-a-long-service-leave-settings></l-a-long-service-leave-settings>

    </div>
</template>


<script>
    export default{

        mounted() {
        },
        props: [],
        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'title' },
                            {label: 'Paid', name: 'paid_flg'},
                            {label: 'Half Day', name: 'can_half'},
                            {label: 'Apportion', name: 'apportion'},
                            {label: 'Encashment', name: 'allow_encashment'},
                            {label: 'Carry', name: 'carry_flg'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
                cu : window.location.href,
                ce : true,
                pagetitle: 'Leave Type',
                search:'',
                leavetypes : [],
                successmsg : '',
                errormsg : [],
                blankmsg : 'Fetching data..',
                fdata : {
                  id:null,
                  title: '' ,
                  can_half:0,
                  can_exceed: 0,
                  paid_flg : 0 ,
                  carry_flg : 0,
                  color_code : '#aaaaaa' ,
                  carry_days:0 ,
                  'full_carry':0 ,
                  'max_carry_forward':0 ,
                  'apportion':1,
                  'rounding':1,
                  'allow_encashment':0,
                  'based_on_salary_type':0,
                  encashment_rate: 0, // 21 july 2025 asfaq
                  encashable_days_based_on: 0, // 21 july 2025 asfaq
                  maximum_encashable_days_in_year: 0, // 21 july 2025 asfaq
                  allow_yearly_encashment_at_separation:0, // 21 july 2025 asfaq
                  yearly_carry_forward_based_on:0, // 21 july 2025 asfaq
                  lifetime_carry_forward_limit:0, // 21 july 2025 asfaq
                  allow_encashment_on_carry_balance:0, // 21 july 2025 asfaq
                  allow_taking_leave_from_carry_balance: 0, // 21 july 2025 asfaq


                  event: '0',
                  ignore_off_day_on_leave: '0',
                  off_day_on_leave: '0',

                  override_leave_policy: '0',
                  day_ratio: '18',
                },

                showoverlay : false,
                showoverlaymodal : false,

                yes_no:[
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },
                ],
                based_on_salary_types:[
                    { value: "0", text: "Basic salary" },
                    { value: "1", text: "Gross salary" },
                    { value: "2", text: "Fixed Rate" }, // 21 july 2025 asfaq
                ],
                // 21 july 2025 asfaq
              allow_encashment_on_carry_balance:[
                { value: "0", text: "No" },
                { value: "1", text: "Yes" },
              ],
                encashable_days_based_on:[
                    { value: "0", text: "Number of Days" },
                    { value: "1", text: "Percentage" },
                ],
                allow_yearly_encashment_at_separation:[
                    { value: "0", text: "No (Remaining Lapsed)" },
                    { value: "1", text: "As Per encashable Days Per Year" },
                    { value: "2", text: "All Remaining" },
                ],
              yearly_carry_forward_based_on:[
                    { value: "1", text: "None (All Remaining)" },
                    { value: "0", text: "Number of Days" },
                    { value: "2", text: "Percentage" },
                ],
                // 21 july 2025 asfaq


                rounding_options : [
                    { value: "1", text: "Round Up" },
                    { value: "2", text: "Round Down" },
                    { value: "3", text: "Rounded to nearest integer" },
                ],

                columns: columns,
                sortKey: 'title',
                sortOrders: sortOrders,

                length: 10,
                pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                event_options : [
                    { value: "0", text: "Auto" },
                    { value: "1", text: "1" },
                    { value: "2", text: "2" },
                    { value: "3", text: "3" },
                    { value: "4", text: "4" },
                    { value: "5", text: "5" },
                ],

                off_day_on_leave_options:[

                    { value: "0", text: "Include weekend and public holidays in leave days calculation" },
                    { value: "1", text: "Skip weekend and public holidays in leave days calculation" },
                    { value: "2", text: "Include adjacent weekend and public holidays in leave days calculation" },
                ],

                // AbdullahALC chnaged length options
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
                temp_length:20,
                leave_type_details: 'Add Leave Type',

                // AbdullahALC chnaged length options upto this

            }
        },
        methods:{
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },
            getTypeList: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leave/types' , {
                    params: {

                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.leavetypes = response.data;
                    this.leavetypes = this.leavetypes.filter(item => !item.title.includes('Compensatory') && !item.title.includes('Long Service')); // 30 july asfaq

                    this.pagination.total = response.data.length;

                    this.showoverlay = false;

                    if(this.leavetypes.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            },
            editLeaveType:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.errormsg = [];
                this.successmsg = '';
                // Abdullah after edit add this
                this.leave_type_details = 'Edit Leave Type';
                axios.get(this.$api_url+'/leave/type/details/'+x , {
                    params: {

                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.fdata.encashment_rate = response.data.encashment_rate;
                    this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });

                this.$bvModal.show('bv-modal-example');

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                  id:null,
                  title: '' ,
                  can_half:0,
                  can_exceed: 0,
                  paid_flg : 0 ,
                  carry_flg : 0,
                  color_code : '#aaaaaa' ,
                  carry_days:0 ,
                  'full_carry':0 ,
                  'max_carry_forward':0 ,
                  'apportion':1,
                  'rounding':1,
                  'allow_encashment':0,
                  'based_on_salary_type':0,
                  encashment_rate: 0, // 21 july 2025 asfaq
                  encashable_days_based_on: 0, // 21 july 2025 asfaq
                  maximum_encashable_days_in_year: 0, // 21 july 2025 asfaq
                  allow_yearly_encashment_at_separation:0, // 21 july 2025 asfaq
                  yearly_carry_forward_based_on:0, // 21 july 2025 asfaq
                  lifetime_carry_forward_limit:0, // 21 july 2025 asfaq
                  allow_encashment_on_carry_balance:0, // 21 july 2025 asfaq
                  allow_taking_leave_from_carry_balance:0, // 21 july 2025 asfaq

                  event: '0',
                  ignore_off_day_on_leave: '0',
                  off_day_on_leave: '0',

                  override_leave_policy: '0',
                  day_ratio: '18',
                };
            },
            addNewLeaveType()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-example');
                // AbdullahALC chnaged ends
                 this.leave_type_details = 'Add Leave Type';
                 // AbdullahALC chnaged ends
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlaymodal = true;
                    e.preventDefault();
                    let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/leave/type/save', formData)
                                .then(function (response)
                                {
                                    currentObj.leavetypes = response.data;
                                    currentObj.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    currentObj.$bvModal.hide('bv-modal-example');
                                    currentObj.showoverlaymodal = false;
                                    currentObj.resetForm();

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.showoverlaymodal = false;
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                        currentObj.$validator.reset();
                                    }
                                });
                });
            },

        },
        created: function(){
            //this.getAcl();
            this.getTypeList();
            Fire.$on('reloadUsers', () => {this.getTypeList()})
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leavetypes;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
